package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class SummaryAnalysisResponse(
    val response: SummaryAnalysis,
)

@Serializable
data class SummaryAnalysis(
    val summary: String,
    val summaryRevision: Int
)
